module.exports = __webpack_public_path__ + "static/media/icon-piece2-5.549006f7.png";